import React from "react"
import ProgressBar from 'react-customizable-progressbar'
class CircularProgress extends React.Component {

  state = {
    textprogress: 60,
    progress: 0,
    timer: 60,
    intervalCode: null
  }

  componentDidMount() {

    this.updateTimer();
  }

  // componentWillMount(){
  //   clearInterval(this.state.intervalCode)
  // }

  updateTimer = () => {
    console.log("update timer method called")
    let counter = 60;
    const interval = setInterval(() => {
      counter--;
      this.setState({
        textprogress: counter
      })
      if (this.state.textprogress === 0) {
        clearInterval(interval);
        this.setState({ textprogress: 0 })

        this.props.updateResendOtpVarFromTimer()
      }
    }, 1000);
  }
  render() {
    return (
      <div style={{display:"flex",flexDirection:'row', justifyContent:'center', maxWidth: '25px', margin:'10px auto'}}>
        <ProgressBar
          progress={this.state.textprogress}
          radius={22}
          steps={60}
          inverse={true}
          counterClockwise={true}
          strokeWidth={4}
          strokeColor="indianred"
          trackStrokeWidth={2}
          pointerRadius={4}
          pointerStrokeWidth={2}
          pointerStrokeColor="indianred"
          pointerFillColor="indianred"
          trackTransition={5}
          children={<span style={{position:'relative', bottom:'40px'}}>{this.state.textprogress}</span>}
        >
        </ProgressBar>
      </div>
    )
  }
}
export default CircularProgress;